export class CatPaymentTermModel {
    public paymentId?:number;
    public description?:string;
    public paymentValue?:number;
    public periodId?:number;
    public termYear?:number;

    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}